goog.provide("shadow.js.shim.module$src$svg$controls$filter_svg$default");
shadow.js.shim.module$src$svg$controls$filter_svg$default = shadow.js.shim.module$src$svg$controls$filter_svg.default;
